"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PACKAGE_FEATURE_KEYS = exports.PACKAGE_FEATURE_IDS = exports.PACKAGE_FEATURES = exports.LEGACY_REPORTS_FEATURE_ALIAS = exports.DEFAULT_GOLD_REPORT_FEATURE_KEYS = exports.GOLD_REPORT_EXPORT_FEATURE_IDS = exports.GOLD_REPORT_NAV_FEATURE_IDS = exports.PACKAGE_FEATURE_GROUPS = exports.LEGACY_PACKAGE_SLUG_ALIASES = void 0;
exports.normalizePackageSlug = normalizePackageSlug;
exports.isPackageFeatureId = isPackageFeatureId;
exports.expandLegacyFeatureKeyAliases = expandLegacyFeatureKeyAliases;
exports.assertFeatureKeysValid = assertFeatureKeysValid;
exports.defaultFeatureKeysForSlug = defaultFeatureKeysForSlug;
exports.reportNavFeatureForSection = reportNavFeatureForSection;
exports.reportExportFeatureForCatalogId = reportExportFeatureForCatalogId;
exports.featuresGroupedForAdmin = featuresGroupedForAdmin;
const gold_report_catalog_1 = require("./gold-report-catalog");
/** Παλιά slugs → νέα (bronze/silver → pro, gold → business). */
exports.LEGACY_PACKAGE_SLUG_ALIASES = {
    bronze: 'pro',
    silver: 'pro',
    gold: 'business',
};
function normalizePackageSlug(slug) {
    var _a;
    const lower = slug.toLowerCase();
    return (_a = exports.LEGACY_PACKAGE_SLUG_ALIASES[lower]) !== null && _a !== void 0 ? _a : lower;
}
exports.PACKAGE_FEATURE_GROUPS = {
    core: { label: 'Προσφορές & CRM' },
    presence: { label: 'Δημόσιο προφίλ' },
    growth: { label: 'Ανάπτυξη & οικονομικά' },
    analytics: { label: 'Αναφορές Business' },
};
function navFeatureId(sectionId) {
    return `reports_nav_${sectionId}`;
}
function exportFeatureId(catalogId) {
    const map = {
        pipeline: 'reports_export_pipeline',
        acceptance: 'reports_export_acceptance',
        'crm-funnel': 'reports_export_crm_funnel',
        tasks: 'reports_export_tasks',
        'follow-up': 'reports_export_follow_up',
        financials: 'reports_export_financials',
        profile: 'reports_export_profile',
        executive: 'reports_export_executive_pdf',
        statistics: 'reports_export_executive_pdf',
        'weekly-summary': 'reports_export_weekly_pdf',
    };
    const key = map[catalogId];
    if (!key) {
        throw new Error(`Unknown gold report catalog id: ${catalogId}`);
    }
    return key;
}
exports.GOLD_REPORT_NAV_FEATURE_IDS = gold_report_catalog_1.goldReportNavSections.map((s) => navFeatureId(s.id));
exports.GOLD_REPORT_EXPORT_FEATURE_IDS = gold_report_catalog_1.goldReportCatalog
    .filter((r) => r.exportBundle)
    .map((r) => exportFeatureId(r.id));
exports.DEFAULT_GOLD_REPORT_FEATURE_KEYS = [
    ...exports.GOLD_REPORT_NAV_FEATURE_IDS,
    ...exports.GOLD_REPORT_EXPORT_FEATURE_IDS,
];
/** Παλιό συλλογικό id — επεκτείνεται σε όλα τα gold report keys. */
exports.LEGACY_REPORTS_FEATURE_ALIAS = 'reports';
const NAV_FEATURES = Object.fromEntries(gold_report_catalog_1.goldReportNavSections.map((section) => {
    const id = navFeatureId(section.id);
    return [
        id,
        {
            id,
            label: section.label,
            description: `Πρόσβαση στη σελίδα ${section.path}`,
            group: 'analytics',
            analyticsSubgroup: 'reports_nav',
            minPackageSlug: 'business',
        },
    ];
}));
const EXPORT_FEATURES = Object.fromEntries(gold_report_catalog_1.goldReportCatalog
    .filter((r) => r.exportBundle)
    .map((entry) => {
    var _a, _b;
    const id = exportFeatureId(entry.id);
    const formats = (_b = (_a = entry.exportFormats) === null || _a === void 0 ? void 0 : _a.join(', ').toUpperCase()) !== null && _b !== void 0 ? _b : 'CSV';
    return [
        id,
        {
            id,
            label: entry.title,
            description: `${entry.valueLine} · εξαγωγή ${formats}`,
            group: 'analytics',
            analyticsSubgroup: 'reports_export',
            minPackageSlug: 'business',
        },
    ];
}));
const CORE_PACKAGE_FEATURES = {
    ai_offers: {
        id: 'ai_offers',
        label: 'Προσφορές AI',
        description: 'Capture (γραφή/φωνή/OCR), οδηγία AI, επεξεργασία, επαναδημιουργία, email/PDF/share',
        group: 'core',
        minPackageSlug: 'basic',
    },
    crm: {
        id: 'crm',
        label: 'CRM πελάτες & εργασίες',
        description: 'Πελάτες, στάδια, tags, εργασίες, timeline, board/list',
        group: 'core',
        minPackageSlug: 'basic',
    },
    appointments: {
        id: 'appointments',
        label: 'Ραντεβού πελατών',
        description: 'Ημερολόγιο ραντεβού, επερχόμενα, σύνδεση με πελάτη',
        group: 'growth',
        minPackageSlug: 'pro',
    },
    public_profile: {
        id: 'public_profile',
        label: 'Δημόσιο προφίλ',
        group: 'presence',
        minPackageSlug: 'pro',
    },
    projects: {
        id: 'projects',
        label: 'Portfolio έργων',
        group: 'presence',
        minPackageSlug: 'pro',
    },
    reviews: {
        id: 'reviews',
        label: 'Αξιολογήσεις πελατών',
        group: 'presence',
        minPackageSlug: 'pro',
    },
    business_card: {
        id: 'business_card',
        label: 'QR & επαγγελματική κάρτα',
        group: 'presence',
        minPackageSlug: 'pro',
    },
    offer_acceptance: {
        id: 'offer_acceptance',
        label: 'Link αποδοχής προσφοράς',
        group: 'growth',
        minPackageSlug: 'pro',
    },
    offer_timeline: {
        id: 'offer_timeline',
        label: 'Timeline προσφοράς',
        group: 'growth',
        minPackageSlug: 'pro',
    },
    notifications: {
        id: 'notifications',
        label: 'Κέντρο ειδοποιήσεων',
        group: 'growth',
        minPackageSlug: 'pro',
    },
    follow_up: {
        id: 'follow_up',
        label: 'Follow-up email',
        group: 'growth',
        minPackageSlug: 'pro',
    },
    expenses: {
        id: 'expenses',
        label: 'Έξοδα & OCR',
        group: 'growth',
        minPackageSlug: 'pro',
    },
    margin: {
        id: 'margin',
        label: 'Margin & οικονομική εικόνα',
        group: 'growth',
        minPackageSlug: 'pro',
    },
};
exports.PACKAGE_FEATURES = {
    ...CORE_PACKAGE_FEATURES,
    ...NAV_FEATURES,
    ...EXPORT_FEATURES,
};
exports.PACKAGE_FEATURE_IDS = Object.keys(exports.PACKAGE_FEATURES);
function isPackageFeatureId(value) {
    return Object.prototype.hasOwnProperty.call(exports.PACKAGE_FEATURES, value);
}
/** Επεκτείνει παλιά id (π.χ. `reports`) σε νέα λίστα. */
function expandLegacyFeatureKeyAliases(keys) {
    const out = [];
    for (const key of keys) {
        if (key === exports.LEGACY_REPORTS_FEATURE_ALIAS) {
            for (const id of exports.DEFAULT_GOLD_REPORT_FEATURE_KEYS) {
                if (!out.includes(id))
                    out.push(id);
            }
            continue;
        }
        if (isPackageFeatureId(key) && !out.includes(key)) {
            out.push(key);
        }
    }
    return out;
}
function assertFeatureKeysValid(keys) {
    return expandLegacyFeatureKeyAliases(keys);
}
const PRO_TIER_FEATURE_KEYS = [
    'public_profile',
    'projects',
    'reviews',
    'business_card',
    'appointments',
    'offer_acceptance',
    'offer_timeline',
    'notifications',
    'follow_up',
    'expenses',
    'margin',
];
/** Default featureKeys ανά billing slug (μόνο τι «πουλάει» το πακέτο). */
exports.DEFAULT_PACKAGE_FEATURE_KEYS = {
    basic: ['ai_offers', 'crm'],
    pro: PRO_TIER_FEATURE_KEYS,
    business: [...exports.DEFAULT_GOLD_REPORT_FEATURE_KEYS],
    // legacy aliases
    bronze: PRO_TIER_FEATURE_KEYS,
    silver: PRO_TIER_FEATURE_KEYS,
    gold: [...exports.DEFAULT_GOLD_REPORT_FEATURE_KEYS],
};
function defaultFeatureKeysForSlug(slug) {
    var _a;
    const normalized = normalizePackageSlug(slug);
    return [...((_a = exports.DEFAULT_PACKAGE_FEATURE_KEYS[normalized]) !== null && _a !== void 0 ? _a : [])];
}
function reportNavFeatureForSection(sectionId) {
    return navFeatureId(sectionId);
}
function reportExportFeatureForCatalogId(catalogId) {
    const entry = gold_report_catalog_1.goldReportCatalog.find((r) => r.id === catalogId);
    if (!(entry === null || entry === void 0 ? void 0 : entry.exportBundle))
        return null;
    return exportFeatureId(entry.id);
}
function reportExportsForSection(sectionId) {
    return gold_report_catalog_1.goldReportCatalog
        .filter((r) => r.exportBundle && r.sectionId === sectionId)
        .map((r) => exports.PACKAGE_FEATURES[exportFeatureId(r.id)]);
}
function featuresGroupedForAdmin() {
    return Object.keys(exports.PACKAGE_FEATURE_GROUPS).map((groupId) => {
        const features = exports.PACKAGE_FEATURE_IDS.filter((id) => exports.PACKAGE_FEATURES[id].group === groupId).map((id) => exports.PACKAGE_FEATURES[id]);
        if (groupId !== 'analytics') {
            return {
                groupId,
                label: exports.PACKAGE_FEATURE_GROUPS[groupId].label,
                features,
            };
        }
        const subgroups = gold_report_catalog_1.goldReportNavSections.map((section) => {
            const nav = exports.PACKAGE_FEATURES[navFeatureId(section.id)];
            const exports = reportExportsForSection(section.id);
            return {
                id: section.id,
                label: section.label,
                path: section.path,
                nav,
                exports,
                features: [nav, ...exports],
            };
        });
        return {
            groupId,
            label: exports.PACKAGE_FEATURE_GROUPS[groupId].label,
            features,
            subgroups,
        };
    });
}
